<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { cloneDeep, debounce } from "lodash";
import { required } from "vuelidate/lib/validators";
import { Carousel, Slide } from "vue-carousel";
import DatePicker from "vue2-datepicker";
import FundCluster from "@/components/modals/fund-cluster-list.vue";
import ItemCategory from "@/components/modals/item-category.vue";
import Supplier from "@/components/modals/supplier.vue";
import Unit from "@/components/modals/unit.vue";
import Employee from "@/components/modals/employee-hris.vue";
import Location from "@/components/modals/property-location.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import PropertyUpdate from "@/components/modals/property-create.vue";
import InventoryItems from "./components/inventory-items.vue";
import NotFoundItems from "./components/not-found-items.vue";
import InventoryForm from "./components/inventory-form.vue";
import InventoryStocks from "./components/inventory-stocks.vue";
import RawData from "@/components/widgets/raw-data.vue";
import StockInventoryModal from "@/components/modals/stock-inventory-modal.vue";
import StockItemModal from "@/components/modals/stock-item-modal.vue";
import CommitteeMemberModal from "@/components/modals/committee-member.vue";

export default {
  page: {
    title: "Inventory",
  },
  components: {
    Layout,
    PageHeader,
    Carousel,
    Slide,
    DatePicker,
    FundCluster,
    ItemCategory,
    Supplier,
    Unit,
    Employee,
    Location,
    PrintOptions,
    PropertyUpdate,
    InventoryItems,
    NotFoundItems,
    InventoryForm,
    InventoryStocks,
    RawData,
    StockInventoryModal,
    StockItemModal,
    CommitteeMemberModal
  },
  data() {
    return {
      title: "Inventory",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Inventory",
          active: true,
        },
      ],
      tableData: [],
      itemData: null,
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "id",
          sortable: true,
          label: "Inventory",
        },
      ],
      inventForm: {
        title: "",
        description: "",
        startDate: "",
      },
      endForm: {
        id: null,
        endDate: "",
        remarks: "",
      },
      returnForm: {
        id: null,
        returnNotes: "",
        dateReturned: "",
      },
      printForm: {
        inventoryId: "",
        fundClusterId: "",
      },
      campusId: this.$store.state.data.selectedCampus.id,
      propertyIndex: -1,
      itemIndex: -1,
      tableBusy: false,
      editMode: false,
      nextPage: false,
      getType: "",
      fundClusterId: "",
      clusterId: "",
      clusterType: "",
      itemCategory: "",
      excelList: [],
      uploadOptions: {
        type: "Property",
        placement: "lefttop",
        folder: "Property",
      },
      accountableEmployee: null,
      getEmployeeType: "",
      assignmentHistoryEmployeeData: null,
      assignmentHistoryLocationData: null,
      conditionChange: "",
      noteChange: "",
      multipleUpdateType: "",
      hubConnector: null,
      filterByEmployee: null,
      filterEmployeeId: null,
      rpType: 'rpcppe',
      selectedProperty: null,
      checkedToggleList: [],
      stocks: [],
    };
  },
  validations: {
    form: {
      name: { required },
      poNumber: { required },
      propertyNumber: { required },
      amount: { required },
      lifespanInYears: { required },
      yearlyDepreciation: { required },
      salvageValue: { required },
      itemCategoryId: { required },
      fundClusterId: { required },
      supplier: { required },
      condition: { required },
      unit: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.title.toUpperCase().includes(this.filter.toUpperCase()))
            return item.title.toUpperCase().includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
  },
  created() {
    this.changeCampus(this.$store.state.data.selectedCampus);

    let connection = new HubConnectionBuilder()
      .withUrl(
        this.$store.state.notification.hubConnection + "notificationhub",
        // {
        //   accessTokenFactory: () => localStorage.getItem("accessToken"),
        // }
      )
      .build();
    connection.on("InventoryItem", (message) => {
      let data = cloneDeep(message);
      data.showDeleteOption = false;
      data.clientDate = this.getDate(new Date());
      data.returnDate = this.diffDate(data.clientDate);
      this.notifications.unshift(data);
      this.showNotification(data);
    });
    connection.start();
  },
  beforeRouteLeave(to, from, next) {
    this.hubConnector.stop();
    return next();
  },
  mounted() {
    this.hubConnector = new HubConnectionBuilder()
      .withUrl(
        this.$store.state.notification.hubConnection + "notificationhub",
        // {
        //   accessTokenFactory: () => localStorage.getItem("accessToken"),
        // }
      )
      .build();
    this.hubConnector.on("InventoryItem", (result) => {
      var data = cloneDeep(result);
      var index = this.tableData.findIndex(
        (item) => item.id == data.inventoryId
      );
      if (this.itemData && this.tableData[index].id == this.itemData.id) {
        this.$store
          .dispatch(
            "propertyinventory/GetPropertyInventoryItemData",
            data.inventoryItemIds
          )
          .then((res) => {
            res.data.forEach((item) => {
              item.property.toggleSelected = false;
              item.property.visible = false;
              item.property.itemVisible = false;
              item.property.assignmentHistory = [];
              item.property.assignVisible = false;
              item.property.assignLoading = false;
              item.property.inspectionVisible = false;
              item.property.attachmentVisible = false;
              item.property.addDocu = false;
              item.property.attachmentLoading = false;
              item.property.fileSearch = "";
              item.propertyInspections.forEach((inspect) => {
                inspect.inspectionFiles = [];
                inspect.attachmentLoading = false;
              });
              this.itemData.inventoryItems.push(item);
            });
            this.showToast(
              `${data.inventoryItemIds.length} ${
                data.inventoryItemIds.length > 1 ? "items are" : "item is"
              } added.`,
              "info"
            );
          })
          .catch(() => {
            this.showToast(
              "Something went wrong - Getting property list!",
              "error"
            );
          });
      }
    });
    this.hubConnector.start();
  },
  methods: {
    delayFilter: debounce(function () {
      this.itemData.filter = this.itemData.searchInput;
      this.itemData.toggleAll = false;
      this.itemData.currentPage = 1;
      this.itemData.tableBusy = false;
    }, 1000),
    changeCampus(data) {
      this.campusId = data.id;
      this.getStockItems(data.id);
      this.getInventory();
      this.returnToTable();
    },
    getInventory() {
      this.tableBusy = true;
      this.$store
        .dispatch("propertyinventory/GetPropertyInventory", this.campusId)
        .then((res) => {
          this.tableBusy = false;
          res.data.forEach((item) => {
            item.toggleAll = false;
            item.currentPage = 1;
            item.perPage = 10;
            item.searchInput = "";
            item.filter = "";
            item.tableBusy = false;
            item.notFoundItems = [];
            item.inventoryItems = [];
            item.stockItems = [];
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting inventory list!",
            "error"
          );
        });
    },
    viewInventoryItems(row) {
      if (this.$refs.carousel) {
        this.itemData = cloneDeep(row);
        this.getProperty();
        this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
      }
    },
    async getNotFoundInStation() {
      this.itemData.notFoundItems = [];
      this.itemData.toggleAll = false;
      this.itemData.tableBusy = true;
      await this.wait(1000);
      await this.$store
        .dispatch(
          "propertyinventory/GetNotFoundInStation",
          this.itemData.id
        )
        .then((res) => {
          if(res.data.error){
            this.showToast(res.data.errorMessage, "error");
            this.itemData.tableBusy = false;
            return;
          }
          res.data.map(x => {
            x.accountableOfficer = x.name || 'Unassigned';
            x.showProperty = false;
            x.filterKey = `${x.name} ${x.items.map(p => p.propertyNumber).join(" ")} ${x.items.map(p => p.propertyName).join(" ")}`;
            x.items.map(item => {
                item.toggleSelected = false;
                item.visible = false;
                item.itemVisible = false;
                item.assignmentHistory = [];
                item.assignVisible = false;
                item.assignLoading = false;
                item.inspectionVisible = false;
                item.attachmentVisible = false;
                item.addDocu = false;
                item.attachmentLoading = false;
                item.fileSearch = "";
                item.filterKey = `${x.accountableOfficer} ${item.propertyNumber} ${item.name} ${item.serialNumber}`;
            })
          })
          this.itemData.notFoundItems = res.data;
          this.itemData.tableBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.itemData.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    returnToTable() {
      if (this.$refs.carousel) {
        this.itemData = null;
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
      }
    },
    async getPropertyList(){
      await this.$store
        .dispatch(
          "propertyinventory/GetPropertyInventoryItemGrouped",
          this.itemData.id
        )
        .then((res) => {
          if(res.data.error){
            this.showToast(res.data.errorMessage, "error");
            this.itemData.tableBusy = false;
            return;
          }
          res.data.map(x => {
            x.accountableOfficer = x.accountableOfficer || 'Unassigned';
            x.showProperty = false;
            x.filterKey = `${x.accountableOfficer} ${x.properties.map(p => p.propertyNumber).join(" ")} ${x.properties.map(p => p.name).join(" ")} ${x.properties.map(p => p.serialNumber).join(" ")}`;
            x.properties.map(item => {
                item.toggleSelected = false;
                item.visible = false;
                item.itemVisible = false;
                item.assignmentHistory = [];
                item.assignVisible = false;
                item.assignLoading = false;
                item.inspectionVisible = false;
                item.attachmentVisible = false;
                item.addDocu = false;
                item.attachmentLoading = false;
                item.fileSearch = "";
                item.propertyInspections.forEach((inspect) => {
                  inspect.inspectionFiles = [];
                  inspect.attachmentLoading = false;
                });
                item.filterKey = `${x.accountableOfficer} ${item.propertyNumber} ${item.name} ${item.serialNumber}`;
            })
          })
          this.itemData.inventoryItems = res.data;
          this.itemData.tableBusy = false;
        })
        .catch((err) => {
          this.itemData.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting property list!",
            "error"
          );
        });
    },
    async getStocks(){
      this.itemData.tableBusy = true;
      await this.$store
        .dispatch(
          "stock/GetInventoryStockItems",
          this.itemData.id
        )
        .then((res) => {
          if(res.data.error){
            this.showToast(res.data.errorMessage, "error");
            this.itemData.tableBusy = false;
            return;
          }
          res.data.map(item => {
            item.selected = false;
            item.isUpdate = false;
            item.balancePerCardCopy = JSON.parse(JSON.stringify(item.balancePerCard));
            item.onHandPerCountCopy = JSON.parse(JSON.stringify(item.onHandPerCount));
          })
          this.itemData.stockItems = res.data;
          this.itemData.tableBusy = false;
        })
        .catch((err) => {
          this.itemData.tableBusy = false;
          this.showToast(
            "Something went wrong - Getting stock items!",
            "error"
          );
        });
    },
    async getProperty() {
      this.itemData.inventoryItems = [];
      this.itemData.toggleAll = false;
      this.itemData.tableBusy = true;
      await this.wait(1000);
      if (this.itemData.type == 3) {
        this.getStocks();
      } else {
        this.getPropertyList();
      }
    },
    onCreate(modalData) {
      modalData.campusId = this.$store.state.data.selectedCampus.id;
      if(modalData.id > 0){
        this.$store.dispatch("propertyinventory/UpdatePropertyInventory", modalData)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.tableData.findIndex(item => item.id == modalData.id);
            this.tableData.splice(index, 1, modalData);
            this.$bvModal.hide("inventory-modal");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong - updating inventory!", "error");
          });
      }else{
        this.$store.dispatch("propertyinventory/CreatePropertyInventory", modalData)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.toggleAll = false;
            res.data.currentPage = 1;
            res.data.perPage = 5;
            res.data.searchInput = "";
            res.data.filter = "";
            res.data.tableBusy = false;
            res.data.notFoundItems = [];
            res.data.inventoryItems = [];
            this.tableData.push(res.data);
            this.$bvModal.hide("inventory-modal");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong - creating inventory!", "error");
          });
      }
    },
    createInventory() {
      this.$refs.inventoryForm.onReset();
      this.modalTitle = "Create Inventory";
      this.$bvModal.show("inventory-modal");
    },
    onEnd() {
      this.submitted = true;
      if (this.endForm.endDate == "" || this.endForm.endDate == null) return;
      this.$swal({
        title: "Are you sure?",
        text: "You are about to set end this inventory.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, end it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinventory/EndPropertyInventory", this.endForm)
            .then((res) => {
              res.data.toggleAll = false;
              res.data.currentPage = 1;
              res.data.perPage = 5;
              res.data.searchInput = "";
              res.data.filter = "";
              res.data.tableBusy = false;
              var index = this.tableData.findIndex(
                (item) => item.id == this.endForm.id
              );
              this.tableData.splice(index, 1, res.data);
              this.onReset();
              this.$bvModal.hide("modal-create");
              this.showToast("Successfully ended", "success");
            })
            .catch((err) => {
              this.showToast("Cannot end!", "error");
            });
          this.submitted = false;
        }
      });
    },
    endInventory(props) {
      this.onReset();
      this.endForm.id = props.id;
      this.endForm.endDate = new Date();
      this.modalTitle = "End Inventory";
      this.$bvModal.show("modal-end");
    },
    editInventory(props) {
      this.modalTitle = "Edit Inventory";
      this.$refs.inventoryForm.updateData(props);
      this.$bvModal.show("inventory-modal");
    },
    deleteInventory(props) {
      var index = this.tableData.indexOf(props);
      this.$swal({
        title: "Are you sure?",
        text: "You are about to delete this inventory.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, dispose it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinventory/DeletePropertyInventory", props.id)
            .then((res) => {
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    deleteItem(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You are about to remove this item from inventory.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("propertyinventory/DeletePropertyInventoryItem", props.id)
            .then((res) => {
              if(res.data.error){
                this.showToast(res.data.errorMessage, "error");
                return;
              }
              this.itemData.inventoryItems.map(item => {
                item.properties = item.properties.filter(prop => prop.id != props.id);
              })
              this.showToast("Successfully removed", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be removed!", "error");
            });
        }
      });
    },
    onUpdateItem(props) {
      props.visible = false;
      props.itemVisible = false;
      props.assignmentHistory = [];
      props.assignVisible = false;
      props.assignLoading = false;
      props.inspectionVisible = false;
      props.attachmentVisible = false;
      props.attachmentLoading = false;
      props.addDocu = false;
      props.fileSearch = "";
      props.propertyInspections.forEach((inspect) => {
        inspect.inspectionFiles = [];
        inspect.attachmentLoading = false;
      });
      this.selectedProperty = props;
    },
    updateItem(props) {
      this.selectedProperty = JSON.parse(JSON.stringify(props));
      this.$refs.propertyupdate.updateProperty(props.propertyId);
    },
    onChangeMultiple() {
      this.submitted = true;
      if (this.multipleUpdateType == "condition") {
        if (this.conditionChange == null || this.conditionChange == "") return;
        this.onChangeCondition();
      } else if (this.multipleUpdateType == "note") {
        if (this.noteChange == null || this.noteChange == "") return;
        this.onChangeNote();
      }
      this.submitted = false;
    },
    onChangeCondition() {
      var condition = this.conditionChange;
      var propertyIds = this.checkedToggleList.map(prop => prop.propertyId);
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${propertyIds.length > 1 ? "properties" : "property"} selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/updateCondition", { propertyIds, condition })
            .then((res) => {
              this.itemData.inventoryItems.forEach((item) => {
                item.properties.map(prop => {
                  if (propertyIds.includes(prop.propertyId)) {
                    prop.condition = this.conditionChange;
                  }
                })
              });
              this.conditionChange = "";
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed condition", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change condition!", "error");
            });
        }
      });
    },
    onChangeNote() {
      var note = this.noteChange;
      var propertyIds = this.checkedToggleList.map(prop => prop.propertyId);
      this.$swal({
        title: "Are you sure?",
        text: `${propertyIds.length} ${
          propertyIds.length > 1 ? "properties" : "property"
        } selected.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, change it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("property/updateNote", { propertyIds, note })
            .then((res) => {
              this.itemData.inventoryItems.forEach((item) => {
                item.properties.map(prop => {
                  if (propertyIds.includes(prop.id)) {
                    prop.note = this.noteChange;
                  }
                })
              });
              this.noteChange = "";
              this.$bvModal.hide("modal-multiple-update");
              this.showToast("Successfully changed remarks", "success");
            })
            .catch((err) => {
              this.showToast("Cannot change remarks!", "error");
            });
        }
      });
    },
    changeCondition(list) {
      this.checkedToggleList = list;
      this.multipleUpdateType = "condition";
      this.conditionChange = "";
      this.submitted = false;
      this.modalTitle = "Change Condition";
      this.$bvModal.show("modal-multiple-update");
    },
    changeNote(list) {
      this.checkedToggleList = list;
      this.multipleUpdateType = "note";
      this.noteChange = "";
      this.submitted = false;
      this.modalTitle = "Change Remark";
      this.$bvModal.show("modal-multiple-update");
    },
    onReset() {
      this.endForm = {
        id: null,
        endDate: "",
        remarks: "",
      };
      this.printForm = {
        inventoryId: "",
        fundClusterId: "",
      };
      this.getType = "";
      this.fundClusterId = "";
      this.itemCategory = "";
      this.editMode = false;
      this.submitted = false;
      this.propertyIndex = -1;
      this.itemIndex = -1;
    },
    getEmployee(type) {
      this.$refs.employee.resetData();
      this.$bvModal.show("externalEmployee-modal");
      this.getEmployeeType = type;
    },
    dropEmployee(data) {
      this.itemData.currentPage = 1;
      this.assignmentHistoryEmployeeData = data;
    },
    getLocation() {
      this.$refs.location.getData(this.campusId);
      this.$bvModal.show("location-modal");
    },
    dropLocation(data) {
      this.assignmentHistoryLocationData = data;
    },
    selectFundCluster(inventoryId, type) {
      this.onReset();
      this.rpType = type;
      this.printForm.inventoryId = inventoryId;
      this.modalTitle = 'Print RPCPPE';
      if(type === "rpcsp"){
        this.modalTitle = 'Print RPCSP';
      }else if(type === 'rpci'){
        this.modalTitle = 'Print RPCI';
      }
      this.$bvModal.show("modal-select-cluster");
    },
    async printRPCPPE() {
      var inventoryId = this.printForm.inventoryId;
      var fundClusterId = this.printForm.fundClusterId;
      var apiUrl = `api/Report/Property/Inventory/Campus`;
      var routeVariables = [inventoryId, fundClusterId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.onReset();
      this.$bvModal.hide("modal-select-cluster");
      this.$bvModal.show("print-options-modal");
    },
    async printRPCI() {
      var inventoryId = this.printForm.inventoryId;
      var fundClusterId = this.printForm.fundClusterId;
      var apiUrl = `api/Report/Property/Inventory/RPCI`;
      var routeVariables = [inventoryId, fundClusterId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: []
      });
      this.onReset();
      this.$bvModal.hide("modal-select-cluster");
      this.$bvModal.show("print-options-modal");
    },
    async printRPCSP() {
      var inventoryId = this.printForm.inventoryId;
      var fundClusterId = this.printForm.fundClusterId;
      var apiUrl = `api/Report/Property/Inventory/RPCSP/Campus`;
      var routeVariables = [inventoryId, fundClusterId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.onReset();
      this.$bvModal.hide("modal-select-cluster");
      this.$bvModal.show("print-options-modal");
    },
    async printRPCPPEAll() {
      var campusId = this.campusId;
      var fundClusterId = this.printForm.fundClusterId;
      var apiUrl = `api/Report/Property/Inventory/All/Campus`;
      var routeVariables = [campusId, fundClusterId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.onReset();
      this.$bvModal.hide("modal-select-cluster");
      this.$bvModal.show("print-options-modal");
    },
    async printRPCSPAll() {
      var campusId = this.campusId;
      var apiUrl = `api/Report/Property/Inventory/RPCSP/All`;
      var routeVariables = [campusId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.onReset();
      this.$bvModal.hide("modal-select-cluster");
      this.$bvModal.show("print-options-modal");
    },
    async printParProperty(id) {
      var apiUrl = `api/Report/Property/PAR`;
      var routeVariables = [];
      var body = [];
      body.push(id);
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body,
      });
      this.$bvModal.show("print-options-modal");
    },
    async printIcsProperty(id) {
      var apiUrl = `api/Report/Property/ICS`;
      var routeVariables = [];
      var body = [];
      body.push(id);
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body,
      });
      this.$bvModal.show("print-options-modal");
    },
    async printStickerProperty(propertyId) {
      var apiUrl = `api/Report/Property/Property/Sticker/Property`;
      var routeVariables = [propertyId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.$bvModal.show("print-options-modal");
    },
    async printPropertyCard(propertyId) {
      var apiUrl = `api/Report/Property/Property/Card`;
      var routeVariables = [propertyId];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: { propertyId }
      });
      this.$bvModal.show("print-options-modal");
    },
    async printStickerMultiple(list) {
      var apiUrl = `api/Report/Property/Property/Sticker/Properties`;
      var routeVariables = [];
      var body = list.map(prop => prop.propertyId);
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body,
      });
      this.$bvModal.show("print-options-modal");
    },
    getFundCluster(type) {
      this.clusterType = type;
      this.$refs.fundcluster.getData();
      this.$bvModal.show("fund-cluster-modal");
    },
    dropFundCluster(data) {
      if (this.clusterType == "create-modal") {
        this.$refs.propertyupdate.dropFundCluster(data);
      } else if (this.clusterType == "get") {
        this.printForm.fundClusterId = data.id;
        this.fundClusterId = data.cluster;
      }
    },
    getItemCategory() {
      this.$refs.itemcategory.filterPropertyCategory();
      this.$bvModal.show("item-category-modal");
    },
    dropItemCat(data) {
      this.$refs.propertyupdate.dropItemCat(data);
    },
    getSupplier() {
      this.$bvModal.show("supplier-modal");
    },
    dropSupplier(data) {
      this.$refs.propertyupdate.dropSupplier(data);
    },
    getUnit() {
      this.$refs.unit.getData();
      this.$bvModal.show("unit-modal");
    },
    dropUnit(data) {
      this.$refs.propertyupdate.dropUnit(data);
    },
    toggleAll(row, propertyRow, currentPage, perPage) {
      row.inventoryItems.forEach((item) => {
        item.property.toggleSelected = false;
      });
      if (row.toggleAll === true) {
        propertyRow.sort((a, b) => a.id - b.id);
        var total = currentPage * perPage;
        var currentData = propertyRow.slice(total - perPage, total);
        if (currentPage > 1 && currentData.length == 0) {
          total = (currentPage - 1) * perPage;
          currentData = propertyRow.slice(total - perPage, total);
        }
        currentData.forEach((item) => {
          item.property.toggleSelected = true;
        });
      }
    },
    cancelFilterEmployee() {
      this.filterByEmployee = null;
      this.filterEmployeeId = null;
    },
    printRP(){
      if(this.printForm.inventoryId == 0){
        if(this.rpType == 'rpcppe'){
          return this.printRPCPPEAll();
        } else {
          return this.printRPCSPAll();
        }
      }
      if(this.printForm.fundClusterId == ''){
        this.printForm.fundClusterId = 0;
      }
      if(this.rpType == 'rpcppe'){
         return this.printRPCPPE();
      } else if(this.rpType == 'rpcsp'){
        return this.printRPCSP();
      } else if(this.rpType == 'rpci'){
        return this.printRPCI();
      }
      return this.showToast("No report selected", "error");
    },
    printDemandLetter(employee){
        var apiUrl = `Property/Inventory/DemandLetter`;
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: [this.itemData.id, employee.employeeIdNumber],
          body: { hasBody: true }
        });
        this.$bvModal.show("print-options-modal");
    },
    printNoDemandLetter(item){
        var apiUrl = `Property/Inventory/NoDemandLetter`;
        this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: [this.itemData.id, item.employeeIdNumber],
          body: { hasBody: true }
        });
        this.$bvModal.show("print-options-modal");
    },
    printICF({ item, type }){
      var apiUrl = `Property/Inventory/NotFound/ICF`;
      var routeVariables = [this.itemData.id, item.employeeIdNumber];
      var body = { hasBody: true };
      if(type == 'high'){
        apiUrl = `Property/Inventory/Report/ICF/HighValue`;
        routeVariables = [item.employeeIdNumber, this.itemData.id];
        body = null;  
      }else if(type == 'low'){
        apiUrl = `Property/Inventory/Report/ICF/LowValue`;
        routeVariables = [item.employeeIdNumber, this.itemData.id];
        body = null;  
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    },
    async getStockItems(id) {
      await this.$store
        .dispatch("stock/GetStocks", id)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.forEach((item) => {
            item.filterPrice = "";
            item.filter = "";
            item.visible = false;
            item.transactionLoading = false;
            item.transactions = [];
            item.selected = false;
          });
          this.stocks = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong - Getting stock list!", "error");
        });
    },
    addStockItem(){
      this.$refs.simRef.resetData(this.itemData.stockItems);
      this.$bvModal.show("stock-inventory-modal");
    },
    submitStockItem(modalData){
      modalData.inventoryId = this.itemData.id;
      if(modalData.id && modalData.id > 0){
        this.$store.dispatch("stock/UpdateInventoryStockItem", modalData)
          .then((res) => {
            if(res.data.error){
              return this.showToast(res.data.errorMessage, "error");
            }
            let index = this.itemData.stockItems.findIndex(item => item.id == modalData.id);
            modalData.isUpdate = false;
            this.itemData.stockItems.splice(index, 1, modalData);
            this.$bvModal.hide("stock-item-modal");
            this.showToast("Successfully updated stock item!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong - updating stock item!", "error");
          });
      }else{
        this.$store.dispatch("stock/CreateInventoryStockItem", modalData)
          .then((res) => {
            if(res.data.error){
              return this.showToast(res.data.errorMessage, "error");
            }
            this.$bvModal.hide("stock-inventory-modal");
            this.showToast("Successfully added stock item!", "success");
            this.getStocks();
          })
          .catch((err) => {
            this.showToast("Something went wrong - adding stock item!", "error");
          });
      }
    },
    updateStockItem(data){
      this.$refs.stockItemRef.updateData(data);
      this.$bvModal.show("stock-item-modal");
    },
    viewInventoryCommittee(data){
      this.modalTitle = `Inventory Committee for (${data.title})`;
      this.$refs.committeeMemberRef.getData(data);
      this.$bvModal.show("committee-member-modal");
    },
  },
};
</script>

<template>
  <Layout @changeCampus="changeCampus">
    <PageHeader :title="title" :items="items" />
    <!-- End Inventory -->
    <b-modal
      id="modal-end"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="onEnd" class="needs-validation" ref="fcForm">
        <div class="mb-3">
          <label for="endDate">End Date</label>
          <date-picker
            v-model="endForm.endDate"
            :first-day-of-week="1"
            lang="en"
            placeholder="Enter End Date..."
            :class="{
              'is-invalid':
                submitted && (endForm.endDate == '' || endForm.endDate == null),
            }"
          ></date-picker>
          <div
            v-if="
              submitted && (endForm.endDate == '' || endForm.endDate == null)
            "
            class="invalid-feedback"
          >
            <span>This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="remark">Remark </label>
          <textarea
            id="remark"
            rows="2"
            v-model="endForm.remarks"
            placeholder="Enter remark..."
            class="form-control"
            autocomplete="off"
          ></textarea>
        </div>
        <div class="d-flex flex-row-reverse">
          <button type="submit" class="btn btn-danger">End</button>
        </div>
      </form>
    </b-modal>
    <!-- Update Multiple -->
    <b-modal
      id="modal-multiple-update"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="multipleUpdateType == 'condition'">
        <label for="condition">Condition </label>
        <b-form-select
          class="form-select"
          :class="{
            'is-invalid':
              submitted && (conditionChange == null || conditionChange == ''),
          }"
          v-model="conditionChange"
        >
          <b-form-select-option value="" disabled
            >Select Condition...</b-form-select-option
          >
          <b-form-select-option value="In good condition"
            >In good condition</b-form-select-option
          >
          <b-form-select-option value="Needing Repair"
            >Needing Repair</b-form-select-option
          >
          <b-form-select-option value="Unserviceable"
            >Unserviceable</b-form-select-option
          >
          <b-form-select-option value="Obsolete">Obsolete</b-form-select-option>
          <b-form-select-option value="No longer needed"
            >No longer needed</b-form-select-option
          >
          <b-form-select-option value="Not used since purchase"
            >Not used since purchase</b-form-select-option
          >
        </b-form-select>
        <div
          v-if="submitted && (conditionChange == null || conditionChange == '')"
          class="invalid-feedback"
        >
          <span>This value is required.</span>
        </div>
      </div>
      <div v-else-if="multipleUpdateType == 'note'">
        <label for="note">Remark</label>
        <textarea
          id="note"
          rows="4"
          v-model="noteChange"
          placeholder="Enter Remark..."
          class="form-control"
          :class="{
            'is-invalid':
              submitted && (conditionChange == null || conditionChange == ''),
          }"
          autocomplete="off"
        ></textarea>
        <div
          v-if="submitted && (noteChange == null || noteChange == '')"
          class="invalid-feedback"
        >
          <span>This value is required.</span>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-primary mt-3"
          type="button"
          id="inputGroupFileAddon04"
          @click="onChangeMultiple"
        >
          Change
        </button>
      </div>
    </b-modal>
    <!-- Print RPCPPE -->
    <b-modal
      id="modal-select-cluster"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
    >
      <div class="mb-4">
        <label for="fundClusterId">Select Fund Cluster </label>
        <b-input-group>
          <template #append>
            <b-button @click="getFundCluster('get')" variant="outline-info"
              ><i class="mdi mdi-clipboard-text-search-outline"></i
            ></b-button>
          </template>
          <input
            autocomplete="off"
            type="text"
            disabled
            placeholder="Search Fund Cluster..."
            class="form-control"
            v-model="fundClusterId"
          />
        </b-input-group>
      </div>
      <button
        type="button"
        @click="printRP"
        class="btn btn-md btn-block btn-primary d-flex align-items-center justify-content-center mb-2"
      >
        <i class="bx bx-download fs-6 me-2"></i>Print {{ rpType.toUpperCase() }}
      </button>
    </b-modal>
    <!-- Main -->
    <div
      class="card border-4 border-top border-start-0 border-end-0 border-primary"
    >
      <div class="card-body">
        <carousel
          ref="carousel"
          class="events navs-carousel"
          id="timeline-carousel"
          :navigation-enabled="false"
          :pagination-enabled="false"
          :perPage="1"
          :autoplay="false"
          :minSwipeDistance="0"
          :mouseDrag="false"
          :adjustableHeight="true"
        >
          <slide class="custom-table-responsive">
            <div class="row mb-3">
              <div class="col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0 mt-2">List of Inventories</h5>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center float-end">
                  <button
                    type="button"
                    @click="selectFundCluster(0, 'rpcppe')"
                    class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                  >
                    <i class="bx bx-printer fs-6 me-1"></i>Print RPCPPE
                  </button>
                  <button
                    type="button"
                    @click="selectFundCluster(0, 'rpcsp')"
                    class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                  >
                    <i class="bx bx-printer fs-6 me-1"></i>Print RPCSP
                  </button>
                  <button
                    type="button"
                    @click="createInventory()"
                    class="btn btn-sm btn-success d-flex align-items-center ms-1"
                  >
                    <i class="bx bx-plus fs-6 me-1"></i>Create Inventory
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <div class="d-flex float-end">
                  <div id="tickets-table_filter" class="dataTables_filter me-1">
                    <label class="d-inline-flex align-items-center">
                      <b-form-input
                        autocomplete="off"
                        v-model="filter"
                        type="search"
                        @input="currentPage = 1"
                        placeholder="Search inventory..."
                        class="form-control"
                      ></b-form-input>
                    </label>
                  </div>
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center mb-0">
                      <b-form-select
                        class="form-select"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                      >
                      </b-form-select>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-table-responsive mb-0 mt-2">
              <b-table
                class="propertyTable datatables target-table"
                :items="filtered"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="tableBusy"
                bordered
                striped
                show-empty
              >
                <template #empty>
                  <b-card-header>
                    <div class="text-center">
                      <div v-if="filter != ''">
                        <i class="fas fa-exclamation-triangle me-2"></i>There
                        are no inventories matching your request
                      </div>
                      <div v-else>
                        <i class="fas fa-exclamation-triangle me-2"></i>No inventories
                        available
                      </div>
                    </div>
                  </b-card-header>
                </template>
                <template #table-busy>
                  <b-card-header>
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </b-card-header>
                </template>
                <template #cell(id)="row">
                  <div class="position-relative ms-1">
                    <RawData
                      :data="row.item"
                      v-if="$store.state.decrypt.isAdmin()"
                    />
                  </div>
                  <b-card-header
                    header-tag="header"
                    class="border ps-2"
                    role="tab"
                  >
                    <div class="float-end d-flex align-items-center">
                      <div class="font-size-12 me-3" style="width: max-content">
                        <a
                          href="javascript: void(0);"
                          class="text-info d-flex align-items-center"
                          @click="viewInventoryItems(row.item)"
                        >
                          View Details
                          <i
                            class="bx bx-chevron-right rotate font-size-14"
                          ></i>
                        </a>
                      </div>
                      <i
                        class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                        :id="`inventory-popover-${row.item.id}`"
                        tabindex="0"
                      ></i>
                      <b-popover
                        :target="`inventory-popover-${row.item.id}`"
                        triggers="click blur"
                        placement="leftbottom"
                        variant="secondary"
                        custom-class="p-0"
                      >
                        <b-list-group class="w-100 fit">
                          <template v-if="row.item.type == 3">
                            <b-list-group-item
                              button
                              action
                              class="d-flex align-items-center text-purple"
                              @click="selectFundCluster(row.item.id, 'rpci')"
                              ><i class="bx bx-printer font-size-18 me-1"></i
                              >Print RPCI</b-list-group-item
                            >
                          </template>
                          <template v-else>
                            <b-list-group-item
                              button
                              action
                              class="d-flex align-items-center text-purple"
                              @click="selectFundCluster(row.item.id, 'rpcppe')"
                              ><i class="bx bx-printer font-size-18 me-1"></i
                              >Print RPCPPE</b-list-group-item
                            >
                            <b-list-group-item
                              button
                              action
                              class="d-flex align-items-center text-purple"
                              @click="selectFundCluster(row.item.id, 'rpcsp')"
                              ><i class="bx bx-printer font-size-18 me-1"></i
                              >Print RPCSP</b-list-group-item
                            >
                          </template>
                          <b-list-group-item
                            v-if="row.item.status == 'ONGOING'"
                            button
                            action
                            class="d-flex align-items-center text-warning"
                            @click="endInventory(row.item)"
                            ><i
                              class="mdi mdi-calendar-remove-outline font-size-18 me-1"
                            ></i
                            >End Inventory</b-list-group-item
                          >
                          <b-list-group-item
                            button
                            action
                            class="d-flex align-items-center text-success"
                            @click="editInventory(row.item)"
                            ><i class="mdi mdi-pencil font-size-18 me-1"></i
                            >Edit</b-list-group-item
                          >
                          <b-list-group-item
                            button
                            action
                            class="d-flex align-items-center text-danger"
                            @click="deleteInventory(row.item)"
                            ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                            >Delete</b-list-group-item
                          >
                        </b-list-group>
                      </b-popover>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <b class="text-white font-size-14">{{
                          row.item.title
                        }}</b>
                        <div>
                          <b v-if="row.item.status == 'ONGOING'">
                            Start Date:
                            {{ formatDate(new Date(row.item.startDate)) }}
                          </b>
                          <b v-else>
                            End Date:
                            {{ formatDate(new Date(row.item.endDate)) }}
                          </b>
                        </div>
                        <div class="d-flex gap-1 align-items-center mt-1">
                          <div
                            class="badge d-flex align-items-center"
                            :class="[row.item.status == 'ONGOING' ? 'bg-success' : 'bg-danger']"
                          >
                            <small class="font-size-10">{{
                              row.item.status
                            }}</small>
                          </div>
                          <button type="button" class="btn btn-xs btn-outline-info" @click="viewInventoryCommittee(row.item)">
                            <i class="bx bx-user"></i> View Committee Members
                          </button>
                        </div>
                      </div>
                    </div>
                  </b-card-header>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div v-if="rows > 0" class="col">
                Showing {{ (currentPage - 1) * perPage + 1 }} -
                {{
                  rows > (currentPage - 1) * perPage + perPage
                    ? (currentPage - 1) * perPage + perPage
                    : rows
                }}
                of {{ rows }}
              </div>
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul
                    class="pagination pagination-rounded mb-0"
                    style="z-index: -1"
                  >
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </slide>
          <slide class="custom-table-responsive">
            <div v-if="itemData" class="mb-3">
              <div class="d-flex justify-content-between align-start">
                  <div class="d-flex">
                      <h5 class="m-0 me-1">
                      <a href="javascript:void(0);" @click="returnToTable()"
                          ><i class="bx bx-left-arrow-alt fs-2"></i
                      ></a>
                      </h5>
                      <div>
                      <h5 class="m-0">{{ itemData.title }}</h5>
                      <h6 class="m-0">
                          {{
                          itemData.status == "ONGOING" ? formatDate(new Date(itemData.startDate)): formatDate(new Date(itemData.endDate))
                          }}
                      </h6>
                      <div
                          class="badge"
                          :class="
                          itemData.status == 'ONGOING'
                              ? 'bg-success'
                              : 'bg-danger'
                          "
                      >
                          <small class="font-size-10">{{ itemData.status }}</small>
                      </div>
                      </div>
                  </div>
                  <div class="d-flex gap-1 h-100" v-if="itemData.type != 3">
                      <div id="tickets-table_filter" class="dataTables_filter me-1">
                        <label class="d-inline-flex align-items-center mb-0">
                            <b-form-input
                            autocomplete="off"
                            @keyup="
                                itemData.tableBusy = true;
                                delayFilter();
                            "
                            v-model="itemData.searchInput"
                            type="search"
                            placeholder="Search Property..."
                            class="form-control"
                            ></b-form-input>
                        </label>
                      </div>
                      <div>
                        <label class="d-inline-flex align-items-center mb-0">
                          <b-form-select
                            class="form-select"
                            v-model="itemData.perPage"
                            size="sm"
                            :options="pageOptions"
                          >
                          </b-form-select>
                        </label>
                      </div>
                  </div>
              </div>
              <template v-if="itemData.type == 3">
                <InventoryStocks
                  :itemData="itemData"
                  @add-stock="addStockItem"
                  @update-item="submitStockItem"
                  @print-rpci="selectFundCluster(itemData.id, 'rpci')"
                  @view-members="viewInventoryCommittee(itemData)"
                />
              </template>
              <template v-else>
                <b-tabs class="mt-2">
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                          <i class="bx bx-layer text-info"></i>
                      </span>
                      <span class="d-none d-sm-inline-block"><i class="bx bx-layer me-1"></i>All Properties</span>
                    </template>
                    <div class="mt-2">
                      <InventoryItems
                        :itemData="itemData"
                        :assignmentHistoryEmployeeData="assignmentHistoryEmployeeData"
                        :assignmentHistoryLocationData="assignmentHistoryLocationData"
                        @printStickerMultiple="printStickerMultiple"
                        @changeCondition="changeCondition"
                        @changeNote="changeNote"
                        @selectFundCluster="selectFundCluster(itemData.id, $event)"
                        @printParProperty="printParProperty"
                        @printIcsProperty="printIcsProperty"
                        @printStickerProperty="printStickerProperty"
                        @printPropertyCard="printPropertyCard"
                        @updateItem="updateItem($event)"
                        @deleteItem="deleteItem($event)"
                        @getEmployee="getEmployee"
                        @getLocation="getLocation"
                        @print-icf="printICF"
                        @print-certificate="printNoDemandLetter"
                      />
                    </div>
                  </b-tab>
                  <b-tab @click="getNotFoundInStation">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                          <i class="bx bx-info-circle text-info"></i>
                        </span>
                      <span class="d-none d-sm-inline-block"><i class="bx bx-info-circle me-1"></i>Not Found In Station</span>
                    </template>
                    <NotFoundItems 
                      :itemData="itemData" 
                      @printDemandLetter="printDemandLetter"
                      @printICF="printICF({item: $event, type: null})"
                    />
                  </b-tab>
                </b-tabs>
              </template>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
    <PropertyUpdate 
      ref="propertyupdate"
      @updateData="onUpdateItem($event)"
      @getFundCluster="getFundCluster($event)"
      @getItemCategory="getItemCategory($event)"
      @getSupplier="getSupplier($event)"
      @getUnit="getUnit($event)"
    ></PropertyUpdate>
    <fund-cluster
      ref="fundcluster"
      @dropData="dropFundCluster($event)"
    ></fund-cluster>
    <item-category
      ref="itemcategory"
      @dropData="dropItemCat($event)"
    ></item-category>
    <supplier @dropData="dropSupplier($event)"></supplier>
    <unit ref="unit" @dropData="dropUnit($event)"></unit>
    <Employee ref="employee" @dropData="dropEmployee($event)"></Employee>
    <Location ref="location" @dropData="dropLocation($event)"></Location>
    <print-options ref="printOpt"></print-options>
    <inventory-form ref="inventoryForm" :modalTitle="modalTitle" @submit="onCreate"></inventory-form>
    <StockInventoryModal ref="simRef" @submit="submitStockItem" :stocks="stocks"/>
    <StockItemModal ref="stockItemRef" @submit="submitStockItem"/>
    <CommitteeMemberModal ref="committeeMemberRef" :modalTitle="modalTitle"/>
  </Layout>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}

.tooltip {
  opacity: 1 !important;
}

.slide-enter-active {
  animation: slide-in 0.3s;
}

.slide-leave-active {
  animation: slide-in 0.3s reverse;
}

.fade-enter-active {
  animation: fade-in 0.3s;
}

.fade-leave-active {
  animation: fade-in 0.3s reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes slide-in {
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: 0 0 0 0 !important;
}

.VueCarousel-slide-adjustableHeight {
  display: block !important;
}

.VueCarousel-inner {
  align-items: flex-start !important;
}
</style>
